(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["an-disciplines"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-an-disciplines]').forEach(function (root) {
      var items = root.querySelectorAll('.an-disc__item');
      var imgs = root.querySelectorAll('.an-disc__img');
      function activate(i) {
        items.forEach(function (it, n) { it.classList.toggle('is-active', n === i); });
        imgs.forEach(function (im) { im.classList.toggle('is-active', parseInt(im.dataset.index, 10) === i); });
      }
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { activate(i); });
        it.addEventListener('click', function () { activate(i); });
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-header"]) return;
  try {
    
    (function () {
      var h = document.querySelector('[data-an-header]');
      if (!h) return;
      var isHome = h.getAttribute('data-home') === 'true';
      // Horizon scrolla dentro .page-wrapper, non su window
      var sc = document.querySelector('.page-wrapper');
      // max tra .page-wrapper (scroll desktop Horizon) e finestra (scroll mobile) → funziona su entrambi
      function stop() { return Math.max(sc ? sc.scrollTop : 0, window.scrollY || document.documentElement.scrollTop || 0); }
      function onScroll() { h.classList.toggle('is-transparent', isHome && stop() <= 40); }
      onScroll();
      if (isHome) {
        (sc || window).addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('scroll', onScroll, { passive: true });
      }
      var burger = h.querySelector('[data-an-burger]');
      var mobile = h.querySelector('[data-an-mobile]');
      if (burger && mobile) {
        burger.addEventListener('click', function () {
          if (mobile.hasAttribute('data-open')) { mobile.removeAttribute('data-open'); mobile.setAttribute('hidden', ''); }
          else { mobile.setAttribute('data-open', ''); mobile.removeAttribute('hidden'); }
        });
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-video"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.an-video__card').forEach(function (card) {
      function play() {
        if (card.dataset.loaded) return;
        var id = card.getAttribute('data-youtube');
        if (!id) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        card.querySelector('.an-video__frame').appendChild(f);
        card.dataset.loaded = '1';
        card.classList.add('is-playing');
      }
      card.addEventListener('click', play);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); } });
    });
    document.querySelectorAll('.an-video__carousel').forEach(function (car) {
      var track = car.querySelector('[data-an-vtrack]');
      var prev = car.querySelector('[data-an-vprev]');
      var next = car.querySelector('[data-an-vnext]');
      function step() { var c = track.querySelector('.an-video__card'); return c ? c.offsetWidth + 20 : 300; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
